export default __webpack_public_path__ + "assets/images/2aeadfab5ba1f727d38afb7051c6bdcc.png";